import React, { useState } from "react";
import { auth, db } from "../../firebaseConfig";
import { useNavigate } from "react-router-dom";
import { Row, Col } from "antd";
import { Empty } from "antd";
import { useAuthState } from "react-firebase-hooks/auth";
import { useUserData } from "../../hooks/useUsers";
import Interest from "./Interest";
import { Tabs, Spin } from "antd";
import Match from "./Match";
import {
  collection,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";

export default function Interests() {
  let navigate = useNavigate();
  const [spinner, setSpinner] = useState(true);
  const [user] = useAuthState(auth);
  const { loading, userData } = useUserData(user?.uid);
  const [profiles, setProfiles] = useState([]);

  React.useEffect(() => {
    const profileRef = collection(db, "users");    
    let q = query(
      profileRef,
      where("friendRequests", "array-contains", user?.uid)
    );

    onSnapshot(q, (snapshot) => {
      const profiles = snapshot.docs.map((doc) => ({
        ...doc.data(),
      }));
      setProfiles(profiles);
      setSpinner(false);
    });

  }, [setProfiles, user.uid])

  React.useEffect(() => {
    if (loading) return;
    if (userData && !userData.profileCompleted) {
      navigate('/onboarding');
    } else {
      return
    }
  }, [userData, loading, navigate]);

  function matches() {
    return loading ? (
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <Spin size="large" />
      </div>
    ) : userData?.friends?.length > 0 ? (
      <div style={{ padding: '20px 0' }}>
        <Row gutter={[24, 24]}>
          {userData?.friends.map((userId) => {
            return (
              <Col
                key={userId}
                xs={{ span: 24 }}
                sm={{ span: 12 }}
                md={{ span: 8 }}
                lg={{ span: 6 }}
              >
                <Match userId={userId} />
              </Col>
            );
          })}
        </Row>
      </div>
    ) : (
      <Empty
        imageStyle={{ height: 120 }}
        description={<span>No interests accepted.</span>}
      />
    );
  }

  function interestsReceived() {
    return loading ? (
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <Spin size="large" />
      </div>
    ) : userData?.friendRequests?.length > 0 ? (
      <div style={{ padding: '20px 0' }}>
        <Row gutter={[24, 24]}>
          {userData?.friendRequests.map((userId) => {
            return (
              <Col
                key={userId}
                xs={{ span: 24 }}
                sm={{ span: 12 }}
                md={{ span: 8 }}
                lg={{ span: 6 }}
              >
                <Interest disableButtons={false} userId={userId} />
              </Col>
            );
          })}
        </Row>
      </div>
    ) : (
      <Empty
        imageStyle={{ height: 120 }}
        description={<span>No interests received.</span>}
      />
    );
  }

  function interestSent() {
    return spinner ? (
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <Spin size="large" />
      </div>
    ) : profiles?.length > 0 ? (
      <div style={{ padding: '20px 0' }}>
        <Row gutter={[24, 24]}>
          {profiles?.map((profile) => {
            return (
              <Col
                key={profile.profileId}
                xs={{ span: 24 }}
                sm={{ span: 12 }}
                md={{ span: 8 }}
                lg={{ span: 6 }}
              >
                <Interest disableButtons={true} userId={profile.uid} />
              </Col>
            );
          })}
        </Row>
      </div>
    ) : (
      <Empty
        imageStyle={{ height: 120 }}
        description={<span>No interests received.</span>}
      />
    );
  }

  const tabItems = [
    {
      key: "1",
      label: <h2>Interest Accepted</h2>,
      children: matches(),
    },
    {
      key: "2",
      label: <h2>Interests Received</h2>,
      children: interestsReceived(),
    },
    {
      key: "3",
      label: <h2>Interests Sent</h2>,
      children: interestSent(),
    },
  ];

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      paddingTop: '150px',
      paddingBottom: '20px'
    }}>
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto',
        padding: '20px',
        background: 'rgba(255, 255, 255, 0.95)',
        borderRadius: '20px',
        backdropFilter: 'blur(10px)',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.1)'
      }}>
        <Spin spinning={loading}>
          <Tabs defaultActiveKey="1" items={tabItems} />
        </Spin>
      </div>
    </div>
  );
}